var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useEffect, useState } from 'react';
import WindowEventContext from '../context/window-event-context';
import WindowStateContext from '../context/window-state-context';
export default function useRadioFormItem(itemId, parentWidget, extractor) {
    var _a = useState({}), value = _a[0], setValue = _a[1];
    var stateFromEnv = useContext(WindowStateContext);
    var _onFieldUpdate = useContext(WindowEventContext)._onFieldUpdate;
    var valuesFromEnv = stateFromEnv.fields;
    var getRadioGroupItems = function () {
        var _a, _b, _c, _d, _e;
        var childWidgets = parentWidget.childWidgets;
        if (((_b = (_a = parentWidget === null || parentWidget === void 0 ? void 0 : parentWidget.parentWidget) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'qhboxlayout') {
            childWidgets = (_e = (_d = (_c = parentWidget.parentWidget.parentWidget) === null || _c === void 0 ? void 0 : _c.childWidgets) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.item.map(function (childWidget) { return childWidget.childWidgets[0]; });
        }
        return childWidgets
            .filter(function (widget) {
            return widget.type === 'RadioButton' ||
                widget.type === 'QRadioButton' ||
                widget.type === 'QPushButton' ||
                widget.identifier === itemId;
        })
            .map(function (widget) { return widget.identifier; })
            .reduce(function (obj, id) {
            var _a;
            return (__assign(__assign({}, obj), (_a = {}, _a[id] = false, _a)));
        }, {});
    };
    var onChange = function (evt) {
        var _a;
        var updatedValue = __assign(__assign({}, getRadioGroupItems()), (_a = {}, _a[itemId] = extractor(evt), _a));
        setValue(updatedValue);
        _onFieldUpdate(updatedValue);
    };
    useEffect(function () {
        var _a;
        if (valuesFromEnv && valuesFromEnv[itemId]) {
            var updatedValue = __assign(__assign({}, value), (_a = {}, _a[itemId] = valuesFromEnv[itemId], _a));
            setValue(updatedValue);
        }
        else {
            setValue({});
        }
    }, [valuesFromEnv]);
    return { value: value, id: itemId, onChange: onChange };
}
//# sourceMappingURL=useRadioFormItem.js.map